import http from 'hub-http/clients/apiClient';
const CRM_SEARCH_URI = 'crm-search/search';
export function fetchObjects(data) {
  return http.post(CRM_SEARCH_URI, {
    data
  });
}